angular.module('bmsApp.merrymaids.job')
	.controller('MMCloseJobListCtrl', [
		'$window',
		'$scope',
		'$state',
		'$localStorage',
		'$stateParams',
		'MMJobSvc',
		'LicenseOptionsSvc',
		'$q',
		function (
			$window,
			$scope,
			$state,
			$localStorage,
			$stateParams,
			MMJobSvc,
			LicenseOptionsSvc,
			$q
		) {

			function init() {
				self.query = {};
				var defaultQuery = {
					filter: {
						closed: 0,
						dateRange: {
							startDate: moment().subtract(1, 'month').format(),
							endDate: moment().format()
						},
						licences: null,
					},
					sorting: {
						jobDate: 'desc'
					},
					page: 1,
					count: 25
				};

				if (angular.isObject($stateParams.data) && $stateParams.data.startDate && $stateParams.data.endDate) {
					angular.merge(defaultQuery, {
						filter: {
							dateRange: {
								startDate: $stateParams.data.startDate,
								endDate: $stateParams.data.endDate
							}
						}
					});
				}
				else if(angular.isDefined($localStorage.mmCloseJobListParams)) {
					angular.merge(defaultQuery, $localStorage.mmCloseJobListParams);
				}
				angular.merge(self.query, defaultQuery);

				$scope.$watch(function() {
					return self.query;
				}, function () {
					getJobs();
				}, true);


                self.dateRangeOptions = angular.copy($scope.config.datePicker.range);
                self.dateRangeOptions.options.format = $scope.config.format.date.amShortDate;
                self.dateRangeOptions.options.opens = 'left';
				$scope.MMJobMainCtrl.jobOrQuote = 'job';

				var promises = {
					licenseOptions: LicenseOptionsSvc.license(),
				};
				$q.all(promises)
					.then(function (response) {
						$scope.licenseOptions = response.licenseOptions.data.options;
					});

			}

            function getJobs(){


                self.loading = true;
                self.closeJobList.length = 0;
                var params = angular.copy(self.query);
				$localStorage.mmCloseJobListParams = params;
                MMJobSvc.close.index(params).then(function(response){
                    self.closeJobList = response.data.mm_close_job_list;
                    self.totalJobParts = response.data.mm_total_job_parts_overview.total;
                    self.loading = false;
                    $scope.$emit('MMCloseJobListSideData', response.data.mm_total_job_parts_overview);

					// Check if we've exceeded our page size, if we have, go back
					if (self.totalJobParts > 0 && !response.data.mm_close_job_list.length) {
						let newParams = angular.copy(params);
						newParams.page = 1;
						getJobs();
					}
                });
            }

            function toggleStatus(status) {
                if (status === 0){
                    self.selectedStatus.active = !self.selectedStatus.active;
                }
                else if (status === 1){
                    self.selectedStatus.closed = !self.selectedStatus.closed;
                }
                //make sure that at least one of them is selected
                if (!self.selectedStatus.active && !self.selectedStatus.closed){
                    if (status === 0){
                        self.selectedStatus.closed = !self.selectedStatus.closed;
                    }
                    else if (status === 1){
                        self.selectedStatus.active = !self.selectedStatus.active;
                    }
                }

                if (self.selectedStatus.active && self.selectedStatus.closed){
                    delete self.query.filter.closed;
                }
                else {
                    self.query.filter.closed = (self.selectedStatus.closed && !self.selectedStatus.active) ? 1 : 0;
                }
            }

            function dateRangeChanged() {
				// currently only storing the date range
				$window.localStorage['mm_close_job_list_query'] = JSON.stringify({
					filter: {
						dateRange: self.query.filter.dateRange
					}
				});
			}

			var self = $scope.MMCloseJobListCtrl = {
				methods: {
					init: init,
					dateRangeChanged: dateRangeChanged,
                    toggleStatus: toggleStatus,
					getJobs: getJobs
				},
				closeJobList: {},
				filter: {
                    dateRange: {
                        startDate: moment().subtract(1, 'month').format(),
                        endDate: moment().format()
                    }
				},
				sort: {
					jobDate: 'DESC'
				},
				loading: false,
                pan: {
                    page: 1,
                    limit: 25,
                    count: 25
                },
				totalJobParts: null,
				selectedStatus: {
					active: true,
					closed: false
				}
			}
		}
	]);